var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"openuser"},[_c('el-tabs',{attrs:{"type":"border-card"}},[_c('el-tab-pane',{attrs:{"label":"投标提现"}},[_c('withdrawalYX')],1),_c('el-tab-pane',{attrs:{"label":"敞口提现"}},[_c('withdrawalCK')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }